import { UI, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Button, Center } from 'native-base';
import React from 'react';

export interface OrderHeaderDetailsLoadingProps {
  isMobile?: boolean;
  isBasket: boolean;
  onClose: () => void;
}

export const OrderHeaderDetailsLoading: React.FC<OrderHeaderDetailsLoadingProps> = ({
  isMobile,
  isBasket,
  onClose,
}) => {
  const title = isBasket ? 'cesta' : 'ordem';

  if (isMobile) {
    return (
      <Button
        p={0}
        size={'lg'}
        variant="textLink"
        leftIcon={<UI.Icon name="ArrowLeft" size="xxs" color={Color['neutral.black']} />}
        onPress={onClose}
        justifyContent="start">
        <HStack space={Spacing['inline.nano']} alignItems="center">
          <UI.Text
            color="neutral.black"
            fontSize={Typography['fontsize.lg']}
            variant="semibold"
            textTransform="capitalize">
            {title}
          </UI.Text>
          <UI.Text isLoading width="45px" />
        </HStack>
      </Button>
    );
  }

  return (
    <HStack w="full" justifyContent="space-between" mb={Spacing['stack.xxxs']}>
      <VStack space={Spacing['stack.nano']}>
        <HStack space={Spacing['inline.nano']} alignItems="center">
          <HStack space={Spacing['inline.nano']}>
            <UI.Text color="neutral.black" fontSize={Typography['fontsize.lg']} variant="semibold">
              Detalhes da {title}
            </UI.Text>
          </HStack>
          <UI.Text isLoading w="75px" />
        </HStack>
        <HStack space={Spacing['inline.nano']}>
          <UI.Text variant="semibold" color="neutral.medium">
            Ultima atualização:
          </UI.Text>
          <UI.Text isLoading w="50px" />
        </HStack>
      </VStack>
      <HStack space={Spacing['inline.xxxs']}>
        <Button
          p={0}
          variant="textLink"
          size="lg"
          disabled
          isDisabled
          leftIcon={<UI.Icon name="Pdf" size="xxs" color={Color['brand.tertiary.principal']} />}>
          EXPORTAR
        </Button>
        <Center>
          <UI.IconButton
            testId="close-modal"
            p={0}
            icon="CloseModal"
            iconSize="xxs"
            borderWidth="1px"
            borderColor={Color['brand.primary.principal']}
            iconColor={Color['brand.primary.principal']}
            onPress={onClose}
          />
        </Center>
      </HStack>
    </HStack>
  );
};
